(function () {
  function stepSize(track) {
    var item = track.querySelector('.mt-womo-reviews__item');
    if (!item) return Math.round(track.clientWidth * 0.8);

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return Math.round(item.getBoundingClientRect().width + gap);
  }

  function syncOverflow(root, track) {
    var overflowing = track.scrollWidth - track.clientWidth > 1;
    root.classList.toggle('has-overflow', overflowing);
    return overflowing;
  }

  function center(root, track) {
    if (root.dataset.centerStart !== 'true') return;
    if (track.scrollWidth - track.clientWidth <= 1) return;
    track.scrollLeft = (track.scrollWidth - track.clientWidth) / 2;
  }

  function init(root) {
    if (root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    var track = root.querySelector('[data-reviews-track]');
    if (!track) return;

    syncOverflow(root, track);
    center(root, track);

    root.addEventListener('click', function (event) {
      var prev = event.target.closest('[data-reviews-prev]');
      var next = event.target.closest('[data-reviews-next]');
      if (!prev && !next) return;

      track.scrollBy({ left: prev ? -stepSize(track) : stepSize(track), behavior: 'smooth' });
    });

    var recenterOnResize = function () {
      syncOverflow(root, track);
    };

    if ('ResizeObserver' in window) {
      new ResizeObserver(recenterOnResize).observe(track);
    } else {
      window.addEventListener('resize', recenterOnResize);
    }

    // Images change the track width once decoded, so re-measure after they settle.
    window.addEventListener('load', function () {
      if (syncOverflow(root, track) && track.scrollLeft === 0) center(root, track);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.mt-womo-reviews').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.mt-womo-reviews');
    if (!root) return;
    var track = root.querySelector('[data-reviews-track]');
    if (!track) return;

    var item = event.target.closest('.mt-womo-reviews__item') || event.target;
    track.scrollTo({
      left: item.offsetLeft - (track.clientWidth - item.offsetWidth) / 2,
      behavior: 'smooth'
    });
  });
})();
